module.exports = "../../app/cells/pages/contests/index/hot_contests_cell.rb";